"use client";
import * as dc from "@/components/layout/list/defaultType";
import { Skeleton } from "@radix-ui/themes";
import { useTranslations } from "next-intl";
import { DataInputParams } from "./inputType";
import { GetDataInputElement, getLinkValue, getValueLabel, getValueList } from "./inputFunction";
import { Button } from "antd";
import { useEffect, useState } from "react";
import Icon from "@/components/common/icon/icon";

import { Upload } from "antd";
// import dynamic from "next/dynamic";
// const Upload = dynamic(
//   () =>
//     import("antd")
//       .then((mod) => mod.Upload)
//       .catch(() => {
//         const DummyComponent = () => <></>;
//         return DummyComponent;
//       }),
//   { ssr: false },
// );

export default function UploadInput(params: DataInputParams) {
  const t = useTranslations(params.transitionGroup ?? "contents");
  const [action, setAction] = useState(typeof params.uploadProp?.action === "string" ? params.uploadProp?.action : undefined);

  if (params.formFunction && params.name) {
    if (!params.formFunction[params.name]) {
      params.formFunction[params.name] = {};
    }
    const temp_function = params.formFunction[params.name];
    if (temp_function) {
      temp_function["setAction"] = setAction;
    }
  }

  if (params.loading) {
    return <Skeleton loading={params.loading ?? false}>{(params.loading ?? false) ? "blank" : " "}</Skeleton>;
  } else {
    //Debug(params);
    const prev = params.prev ? GetDataInputElement(params.prev, false, params.values, t) : undefined;
    const unitPrev = params.unitPrev ? GetDataInputElement(params.unitPrev, false, params.values, t) : undefined;
    const unit = params.unit ? GetDataInputElement(params.unit, true, params.values, t) : undefined;
    const next = params.next ? GetDataInputElement(params.next, true, params.values, t) : undefined;

    return (
      <Skeleton loading={params.loading ?? false}>
        {prev}
        {unitPrev}
        <Upload {...params.uploadProp} action={action ?? params.uploadProp?.action}>
          {params.elementProp ? (
            GetDataInputElement(params.elementProp, false, params.values, t)
          ) : (
            <Button icon={<Icon iconName="UploadSimple" iconType="" />}>{t("upload_label")}</Button>
          )}
        </Upload>
        {unit}
        {next}
      </Skeleton>
    );
  }
}
